import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

import { ServiceObjectMapComponent } from "./service-object-map.component";
import { MapsModule } from "../../../core/maps/maps.module";
import { ServiceObjectPopupComponent } from "./popup/service-object-popup.component";
import { RouterModule } from "@angular/router";
import { ButtonsModule } from "ngx-bootstrap";

@NgModule({
  declarations: [
    ServiceObjectMapComponent,
    ServiceObjectPopupComponent
  ],
  entryComponents: [
    ServiceObjectPopupComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    MapsModule,
    RouterModule,
    ButtonsModule.forRoot()
  ]
})
export class ServiceObjectMapModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/map/service-object-map.module.ts